import React from 'react';

interface AccessDeniedContextProps {
  denied: boolean;
  setDenied: React.Dispatch<React.SetStateAction<boolean>>;
}

const AccessDeniedContext = React.createContext<AccessDeniedContextProps | null>(null);

export const AccessDeniedProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [denied, setDenied] = React.useState<boolean>(false);

  return (
    <AccessDeniedContext.Provider value={{ denied, setDenied }}>
      {children}
    </AccessDeniedContext.Provider>
  );
};

export const useAccessDenied = () => {
  const context = React.useContext(AccessDeniedContext);
  if (!context) {
    throw new Error('useAccessDenied must be used within a AccessDeniedContext');
  }
  return context;
};
